import type { UseBulkBiddingViewName } from 'Components/pages/VehiclesList/FiltersHeader/BulkBidding/BulkBiddingModal/useBulkBiddingModalViewName';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerBulkBiddingVehicleRowClickedParams {
	enquiryId: number;
	stage: UseBulkBiddingViewName;
}

export const triggerBulkBiddingVehicleRowClicked = ({
	enquiryId,
	stage,
}: TriggerBulkBiddingVehicleRowClickedParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { label: `${enquiryId}: ${stage}` },
		name: 'dlr_bulk_bidding_vehicle_row_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
